<school-header-ui
  [organisation_name]="hospital_name"
  [organisation_address]="hospital_address"
  [organisation_logo]="hospital_logo"
></school-header-ui>
